export default "__VITE_ASSET__DZMSPTwh__"